import script from "./GestaoProcessosMunicipioView_67.vue?vue&type=script&setup=true&lang=js"
export * from "./GestaoProcessosMunicipioView_67.vue?vue&type=script&setup=true&lang=js"

import "./GestaoProcessosMunicipioView_67.vue?vue&type=style&index=0&id=88f4ef12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88f4ef12"]])

export default __exports__